import React from 'react';

interface ProgressDotsProps {
  filled: number;
  total: number;
  size?: 'sm' | 'md' | 'lg';
}

export default function ProgressDots({ filled, total, size = 'md' }: ProgressDotsProps) {
  const dotSize = size === 'sm' ? 7 : size === 'lg' ? 12 : 10;
  const gap = size === 'sm' ? 4 : size === 'lg' ? 7 : 6;

  return (
    <div style={{ display: 'flex', gap: `${gap}px`, alignItems: 'center', flexWrap: 'wrap' }}>
      {Array.from({ length: total }).map((_, i) => (
        <span
          key={`dot-${i + 1}`}
          style={{
            width: `${dotSize}px`,
            height: `${dotSize}px`,
          }}
          className={i < filled ? 'dot-filled' : 'dot-empty'}
        />
      ))}
    </div>
  );
}